import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import { textFontStyles } from '@makemydeal/dr-ui-bricks-components';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    button {
        width: auto;
        border-width: 1px;
        padding: 11px 20px;
        border-radius: 4px;
        text-transform: none;
        ${textFontStyles('large', 'semibold')}
    }
    @media (max-width: ${BreakPoints.PHONE}) {
        button {
            width: 100%;
        }
    }
`;
